// src/com/trans_plan_launch/TransPlanLaunchAndDownload.js
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import { AppMenuUrl } from '../../value/AppConst';
import TransPlanLaunch from './TransPlanLaunch';
import TransPlanDownload from '../trans_plan_download/TransPlanDownload';

export default function TransPlanLaunchAndDownload({
    menu, parentMenu
}) {
    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    return(
        <TopViewControl>
            {
                (() => {
                    if(menu.menuUrl === AppMenuUrl.TransPlan) {
                        return <TransPlanLaunch viewServiceTags={viewServiceTags} />;
                    }
                    if(menu.menuUrl === AppMenuUrl.TransPlanDownload) {
                        return <TransPlanDownload viewServiceTags={viewServiceTags} />;
                    }
                    return null;
                })()
            }
        </TopViewControl>
    )
}